import { Pipe, PipeTransform } from "@angular/core";
  
@Pipe({
  name: "orderBy"
})
export class OrderByPipe implements PipeTransform {
  transform(array: any, field: string): any[] {
    const newArray = array?.slice();
    newArray?.sort((a: any, b: any) => {
      if (a[field]?.toLowerCase() < b[field]?.toLowerCase()) {
        return -1;
      } else if (a[field]?.toLowerCase() > b[field]?.toLowerCase()) {
        return 1;
      } else {
        return 0;
      }
    });
    return newArray;
  }
}